module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/2@2x_9ba5e71220b537292279ec83faa8a1e4.png";